// extracted by mini-css-extract-plugin
export var steps = "steps-module--steps--HXPiY";
export var steps__wrap = "steps-module--steps__wrap--39QPD";
export var steps__wrap__row = "steps-module--steps__wrap__row--2cDpJ";
export var steps__step = "steps-module--steps__step--3OVwN";
export var steps__step__arrow = "steps-module--steps__step__arrow--1Iebu";
export var steps__step__image = "steps-module--steps__step__image--1aXZb";